/**
 * Footer Component
 *
 * Displays the site footer with links and legal information.
 */

import type { ReactElement } from "react";

export function Footer(): ReactElement {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-surface py-8">
      <div className="container-wide">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <p className="text-sm text-text-secondary">{currentYear} Tatvex. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <span className="text-sm text-text-secondary">Privacy Policy</span>
            <span className="text-sm text-text-secondary">Terms of Service</span>
            <span className="text-sm text-text-secondary">Contact</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
